// src/components/TryOtherMiniTools.js
import React from 'react';
import { Link } from 'react-router-dom';
import { 
    IoImageOutline, 
    IoFilmOutline, 
    IoChatbubblesOutline, 
    IoSwapHorizontalOutline,
    IoCalendarOutline,
    IoSparklesOutline
} from 'react-icons/io5';

// Expanded list including core product features
const allToolsAndFeatures = [
  // Mini-Tools
  { type: 'tool', icon: IoImageOutline, label: "Image BG Remover", to: "/bg-remover" },
  { type: 'tool', icon: IoFilmOutline, label: "Video BG Remover", to: "/video-bg-remover" },
  { type: 'tool', icon: IoChatbubblesOutline, label: "AI Caption Generator", to: "/caption-generator" },
  { type: 'tool', icon: IoSwapHorizontalOutline, label: "Any-to-Any Converter", to: "/any-to-any-converter" },
  // Core Oolook Features
  { type: 'feature', icon: IoSparklesOutline, label: "Explore AI & Automation", to: "/ai-automation" },
  { type: 'feature', icon: IoCalendarOutline, label: "Discover Smart Scheduling", to: "/scheduling" },
];

const TryOtherMiniTools = ({ exclude = '' }) => {
  // Filter out the tool that matches the 'exclude' prop
  const filteredTools = allToolsAndFeatures.filter(tool => tool.label !== exclude);

  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            Explore the Oolook Ecosystem
          </h2>
          <p className="mt-4 text-lg text-dark-text-secondary">
            Go beyond this tool and discover the full power of our AI-powered platform.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-8 sm:mt-20 lg:max-w-none md:grid-cols-2 lg:grid-cols-3">
          {filteredTools.map((tool) => (
            <Link
              key={tool.label}
              to={tool.to}
              className="group flex flex-col items-start p-8 bg-dark-card/40 backdrop-blur-lg rounded-2xl border border-white/10 transform-gpu transition-all duration-300 ease-in-out hover:scale-105 hover:border-dark-accent-start/50 hover:shadow-2xl hover:shadow-dark-accent-start/10"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end mb-6">
                <tool.icon className="h-8 w-8 text-white" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-semibold text-dark-text-primary group-hover:text-white">
                {tool.label}
              </h3>
              <p className="mt-4 text-sm font-semibold text-dark-accent-start group-hover:text-white">
                {tool.type === 'tool' ? 'Try Tool' : 'Learn More'} &rarr;
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TryOtherMiniTools;